import { render, staticRenderFns } from "./FilterSolicitudes.vue?vue&type=template&id=3195f9a7&scoped=true"
import script from "./FilterSolicitudes.vue?vue&type=script&lang=js"
export * from "./FilterSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./FilterSolicitudes.vue?vue&type=style&index=0&id=3195f9a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195f9a7",
  null
  
)

export default component.exports